// extracted by mini-css-extract-plugin
export default {"container":"AvailablePositions_container__J7QjF","title":"AvailablePositions_title__PWaD+"};